import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      border: `solid 1px ${theme.palette.divider}`,
      borderRadius: theme.spacing(3),
    },
    counter: {
      fontWeight: 'bold',
      borderRadius: theme.spacing(0, 2.5, 2.5, 0),
      backgroundColor: theme.palette.divider,
      padding: theme.spacing(0, 1),
      display: 'flex',
      alignItems: 'center',
      marginLeft: 1,
    },
  };
};
